import omit from "lodash.omit";

/**
 * Omits any object key that is in the provided blacklist.
 */
export default function omitDeep(input: any, blacklist: string[]) {
    function omitDeepOnOwnProps(obj: any) {
        if (typeof obj === "undefined") {
            return obj;
        }

        if (!Array.isArray(obj) && !isObject(obj)) {
            return obj;
        }

        if (Array.isArray(obj)) {
            return omitDeep(obj, blacklist);
        }

        let o = {};
        for (const [key, value] of Object.entries(obj)) {
            o[key] = !isNil(value) ? omitDeep(value, blacklist) : value;
        }
        return omit(o, blacklist);
    }

    if (Array.isArray(input)) {
        return input.map(omitDeepOnOwnProps);
    }
    return omitDeepOnOwnProps(input);
}

function isNil(value: any) {
    return value === null || value === undefined;
}

function isObject(obj: any) {
    return typeof obj == "object" && !Array.isArray(obj) && obj !== null;
}
